import { css, SerializedStyles } from '@emotion/react';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { theme } from '@frontend/theme';
import { EmailIcon, Heading, PhoneIconSmall, Text } from '@frontend/design-system';

interface LocationInformationProps {
  locationData: {
    name?: string;
    email?: string;
    phoneNumber?: string;
    logo?: string;
  };
  style?: SerializedStyles | SerializedStyles[];
}

const styles = {
  iconTextWrapper: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
  noMargin: css`
    margin: 0;
  `,
};

export const LocationInformation = ({ locationData, style }: LocationInformationProps) => {
  const { name, email, phoneNumber, logo } = locationData;
  return (
    <section css={style}>
      {logo && <img src={logo} alt='logo' />}
      <Heading level={2} css={styles.noMargin}>
        {name}
      </Heading>
      {email && (
        <div css={styles.iconTextWrapper}>
          <EmailIcon size={16} />
          <Text css={styles.noMargin}>{email}</Text>
        </div>
      )}
      {phoneNumber && (
        <div css={styles.iconTextWrapper}>
          <PhoneIconSmall />
          <Text css={styles.noMargin}>{formatPhoneNumber(phoneNumber, true, true)}</Text>
        </div>
      )}
    </section>
  );
};
